import React, { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "../lib/api";
import { onEvent } from "../lib/realtime";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n.jsx";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const NotificationsBell = ({ pathname }) => {
  const { t, tp } = useI18n();
  const [notifs, setNotifs] = useState([]);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/notifications").then((r) => setNotifs(r.data)).catch(() => {});
  useEffect(() => { load(); const iv = setInterval(load, 30000); return () => clearInterval(iv); }, [pathname]);
  useEffect(() => onEvent((ev) => {
    if (ev.type !== "notification") return;
    load();
    const key = `n_${ev.payload?.type}`; const s = tp(key, ev.payload?.params || {});
    toast(s === key ? ev.payload?.type : s, { id: ev.payload?.id });
  }), [tp]);

  const unread = notifs.filter((n) => !n.read).length;
  const text = (n) => {
    const key = `n_${n.type}`;
    const s = tp(key, n.params || {});
    return s === key ? (n.text || n.type) : s;
  };
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const readOne = async (n) => { if (!n.read) { await api.post(`/notifications/${n.id}/read`); load(); } };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative p-2 -m-2" data-testid="notif-btn" title={t("notifications")}>
          <Bell size={20} className="text-slate-500" />
          {unread > 0 && <span data-testid="notif-badge" className="absolute top-0 right-0 bg-[var(--red)] text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[min(92vw,360px)] p-0">
        <div className="flex items-center justify-between px-3 py-2 border-b">
          <span className="font-semibold text-sm">{t("notifications")}</span>
          {unread > 0 && <button onClick={readAll} data-testid="notif-read-all" className="text-xs text-[var(--amber)] flex items-center gap-1"><CheckCheck size={14} /> {t("mark_all_read")}</button>}
        </div>
        <div className="max-h-[60vh] overflow-y-auto" data-testid="notif-list">
          {notifs.length === 0 && <div className="p-6 text-center text-sm text-[var(--text-3)]">{t("no_notifications")}</div>}
          {notifs.slice(0, 50).map((n) => (
            <button key={n.id} onClick={() => readOne(n)} data-testid={`notif-${n.id}`}
              className={`w-full text-left px-3 py-2.5 border-b text-sm flex gap-2 ${n.read ? "opacity-60" : "bg-[var(--bg)]"}`}>
              {!n.read && <span className="mt-1.5 w-2 h-2 rounded-full bg-[var(--amber)] shrink-0" />}
              <span className="flex-1">
                <div>{text(n)}</div>
                <div className="text-xs text-[var(--text-3)] mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
              </span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
